export default class YichenLoading {

  static instance = new YichenLoading()

  constructor() {
    const div = document.createElement('div')
    div.style.position = 'fixed'
    div.style.top = '0'
    div.style.left = '0'
    div.style.bottom = '0'
    div.style.right = '0'
    // div.style.background = '#00000088'
    div.style.zIndex = 9999999
    div.style.display = 'flex'
    div.style.alignItems = 'center'
    div.style.justifyContent = 'center'
    div.style.display = 'none'
    div.innerHTML = `
    <div style="width: 200px;height: 80px;background: #00000099;color:white;border-radius: 12px;opacity: 0.9;display: flex;align-items: center;justify-content: center;flex-direction: column;">
      <div style="margin-bottom: 8px;" id="mloading-text">${this.text}</div>
      <img src="loading.gif">
    </div>
    `
    document.body.appendChild(div)
    this.div = div
  }

  text = '加载中..'
  div

  show(text) {
    const textView = document.getElementById('mloading-text')
    textView.innerText = text || '加载中..'
    this.div.style.display = 'flex'
  }

  dismiss() {
    this.div.style.display = 'none'
  }

}
